import React from 'react';
import { ButtonClean } from '@fourthwall/components';
import { routing } from '@utils/routing';
import * as S from './TermsFooter.styled';
export const TermsFooter = () => {
    return (React.createElement(S.Container, null,
        "By continuing, you agree to",
        ' ',
        React.createElement(ButtonClean, { to: routing.external.termsOfService, target: "_blank", label: "Terms of Use", appearance: "secondary", withUnderline: true }),
        ' ',
        "applicable to Fourthwall Pro and confirm you have read our",
        ' ',
        React.createElement(ButtonClean, { to: routing.external.privacyPolicy, target: "_blank", label: "Privacy Policy", appearance: "secondary", withUnderline: true })));
};
